import React from "react";

import { MeasurementUnit } from "./measurement_unit_class";

import {
  MeasurementShape,
  MeasurementUnitShape,
} from "../../interfaces/classTypes";

let includedMeasurements = [];

export class Measurement {
  public decimalplaces: number;
  public description: string;
  public id: number;
  public label: string;
  public measurementUnit: MeasurementUnitShape;
  public measurementUnitId: number;

  public name: string;

  constructor(data: MeasurementShape) {
    this.decimalplaces = data.decimalplaces;
    this.description = data.description;
    this.id = data.id;
    this.label = data.label;
    this.measurementUnit = MeasurementUnit.includedMeasurementUnits().find(
      (unit) => unit.id == data.measurementUnitId
    );
    this.measurementUnitId = data.measurementUnitId;
    this.name = data.name;
    this.save();
  }
  save() {
    includedMeasurements.push(this);
  }

  labelWithUnits() {
    if (this.measurementUnit != undefined) {
      return `${this.label} (${this.measurementUnit.label})`;
    } else {
      return `${this.label}`;
    }
  }

  unitsOnly() {
    if (this.measurementUnit != undefined) {
      return ` ${this.measurementUnit.label}`;
    } else {
      return ``;
    }
  }

  static findById(input) {
    return includedMeasurements.find((measurement) => measurement.id == input);
  }
  static includedMeasurements() {
    return includedMeasurements;
  }
}
